import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import {
  getData,
  getColumns,
  getIsLoading,
} from '../redux/selectors/RepatriationsTransactionsHistorySelectors';
import ListTable from '../../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import RepatriationsTransactionsEdit from '../../../internal-repatriations/edit/containers/RepatriationsTransactionsEdit';
import InternalRepatriationsTransactionsDelete from '../../../internal-repatriations/delete/containers/InternalRepatriationsTransactionsDelete';
import RepatriationsTransactionsExecute from '../../../internal-repatriations/execute/containers/RepatriationsTransactionsExecute';
import RepatriationsTransactionsObject from '../../../internal-repatriations/object/containers/RepatriationsTransactionsObject';
import RepatriationsTransactionsConfirm from '../../../internal-repatriations/confirm/containers/RepatriationsTransactionsConfirm';
import { getUserRole } from '../../../../../../common/user/redux/selectors/UserDataSelectors';

class RepatriationsTransactionsHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditModal: false,
      showDeleteModal: false,
      showExecuteModal: false,
      showObjectModal: false,
      showConfirmModal: false,
    };
    this.editTransaction = this.editTransaction.bind(this);
    this.deleteInternalRepatriation = this.deleteInternalRepatriation.bind(this);
    this.applyExecute = this.applyExecute.bind(this);
    this.objectRepatriation = this.objectRepatriation.bind(this);
    this.applyConfirm = this.applyConfirm.bind(this);
  }

  componentDidMount() {
    this.refreshHistories();
  }

  refreshHistories = () => {
    this.props.tableLoadData(
      {
        tableId: TableDefinitions.REPATRIATIONS_TRANSACTIONS_HISTORY.id,
      },
      this.props.appContext.appContext,
      {
        transactionId: this.props.row.original.id,
      },
    );
  }

  showEditFormModal = () => {
    this.setState({
      showEditModal: true,
    });
  }

  hideEditFormModal = () => {
    this.setState({
      showEditModal: false,
    });
  }

  showDeleteFormModal = () => {
    this.setState({
      showDeleteModal: true,
    });
  }

  hideDeleteFormModal = () => {
    this.setState({
      showDeleteModal: false,
    });
  }

  showExecuteFormModal = () => {
    this.setState({
      showExecuteModal: true,
    });
  }

  hideExecuteFormModal = () => {
    this.setState({
      showExecuteModal: false,
    });
  }

  showObjectFormModal = () => {
    this.setState({
      showObjectModal: true,
    });
  }

  hideObjectFormModal = () => {
    this.setState({
      showObjectModal: false,
    });
  }

  showConfirmFormModal = () => {
    this.setState({
      showConfirmModal: true,
    });
  }

  hideConfirmFormModal = () => {
    this.setState({
      showConfirmModal: false,
    });
  }

  editTransaction() {
    this.setState({
      showEditModal: true,
    });
  }

  deleteInternalRepatriation() {
    this.setState({
      showDeleteModal: true,
    });
  }

  applyExecute() {
    this.setState({
      showExecuteModal: true,
    });
  }

  objectRepatriation() {
    this.setState({
      showObjectModal: true,
    });
  }

  applyConfirm() {
    this.setState({
      showConfirmModal: true,
    });
  }

  render() {
    const {
      showEditModal,
      showDeleteModal,
      showExecuteModal,
      showObjectModal,
      showConfirmModal,
    } = this.state;
    return (
      <div>
        {(this.props.row.original.status !== 'DELETED'
          && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
            || this.props.userRole.includes('IPC_TRAY_MANAGER')
            || this.props.userRole.includes('IPC_BAG_MANAGER'))) && (
            <Button className="action-buttons" onClick={this.editTransaction}>
              Edit
            </Button>
        )}
        {this.props.row.original.status === 'OPEN'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')
          || this.props.userRole.includes('NATIONAL_PALLET_BOX_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_TRAY_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_BAG_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_PALLET_BOX_EDITOR')
          || this.props.userRole.includes('NATIONAL_TRAY_EDITOR')
          || this.props.userRole.includes('NATIONAL_BAG_EDITOR')) && (
          <Button className="action-buttons" onClick={this.applyExecute}>
            Execute
          </Button>
        )}
        {this.props.row.original.status !== 'DELETED'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons" onClick={this.deleteInternalRepatriation}>
            Delete
          </Button>
        )}
        {this.props.row.original.status !== 'DELETED'
          && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
            || this.props.userRole.includes('IPC_TRAY_MANAGER')
            || this.props.userRole.includes('IPC_BAG_MANAGER')
            || this.props.userRole.includes('NATIONAL_PALLET_BOX_COORDINATOR')
            || this.props.userRole.includes('NATIONAL_TRAY_COORDINATOR')
            || this.props.userRole.includes('NATIONAL_BAG_COORDINATOR')
            || this.props.userRole.includes('NATIONAL_PALLET_BOX_EDITOR')
            || this.props.userRole.includes('NATIONAL_TRAY_EDITOR')
            || this.props.userRole.includes('NATIONAL_BAG_EDITOR')) && (
            <Button className="action-buttons" onClick={this.objectRepatriation}>
              Object
            </Button>
        )}
        {this.props.row.original.status === 'SERVICED_IN'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')
          || this.props.userRole.includes('NATIONAL_PALLET_BOX_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_TRAY_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_BAG_COORDINATOR')
          || this.props.userRole.includes('NATIONAL_PALLET_BOX_EDITOR')
          || this.props.userRole.includes('NATIONAL_TRAY_EDITOR')
          || this.props.userRole.includes('NATIONAL_BAG_EDITOR')) && (
          <Button className="action-buttons" onClick={this.applyConfirm}>
            Confirm
          </Button>
        )}
        <br />
        <br />
        <ListTable
          listId={TableDefinitions.REPATRIATIONS_TRANSACTIONS_HISTORY.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
        />
        {showEditModal && (
          <RepatriationsTransactionsEdit
            closeDialog={this.hideEditFormModal}
            openDialog={this.showEditFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
        {showDeleteModal && (
          <InternalRepatriationsTransactionsDelete
            closeDialog={this.hideDeleteFormModal}
            openDialog={this.showDeleteFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
        {showExecuteModal && (
          <RepatriationsTransactionsExecute
            closeDialog={this.hideExecuteFormModal}
            openDialog={this.showExecuteFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
        {showObjectModal && (
          <RepatriationsTransactionsObject
            closeDialog={this.hideObjectFormModal}
            openDialog={this.showObjectFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
        {showConfirmModal && (
          <RepatriationsTransactionsConfirm
            closeDialog={this.hideConfirmFormModal}
            openDialog={this.showConfirmFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
  };
}

RepatriationsTransactionsHistoryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  row: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
  refreshTransactions: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RepatriationsTransactionsHistoryContainer);
